var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1781_7881",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H50H0ZM50 50.5H0H50ZM0 50.5V0.5V50.5ZM26 0.5C39.8071 0.5 51 11.6929 51 25.5C51 39.3071 39.8071 50.5 26 50.5H25C38.2548 50.5 49 39.3071 49 25.5C49 11.6929 38.2548 0.5 25 0.5H26Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1781_7881)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4295 17.5556L25.0682 22.5201L18.5615 17.5556V17.557L18.5694 17.5637V24.5153L24.9949 29.587L31.4295 24.7111V17.5556Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0998 16.348L31.4292 17.5556V24.7111L36.6859 20.6752V18.2439C36.6859 18.2439 36.0479 14.7715 33.0998 16.348Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4292 24.7111V33.9919H35.4582C35.4582 33.9919 36.6047 33.8739 36.6872 32.567V20.6752L31.4292 24.7111Z",
    fill: "#34A853"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5701 34.0001V24.5153L18.5615 24.5086L18.5701 34.0001Z",
    fill: "#C5221F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5614 17.5568L16.9 16.3559C13.9519 14.7794 13.3125 18.2505 13.3125 18.2505V20.6817L18.5614 24.5084V17.5568Z",
    fill: "#C5221F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5615 17.5572V24.5088L18.5701 24.5155V17.5639L18.5615 17.5572Z",
    fill: "#C5221F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3125 20.6835V32.5753C13.3937 33.8835 14.5415 34.0003 14.5415 34.0003H18.5706L18.5614 24.5088L13.3125 20.6835Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.7d6f9b19b127b8d5a5875551437d42d0.svg";
export { ForwardRef as ReactComponent };